import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { getList, addData } from '../../helpers/fackBackend_Helper';


function* getVendorResponse() {
    try {
        const response = yield call(getList, "/API/V1/Generic/GetVendor");
        if (response?.statusCode === 1200) {
            yield put(actions.getVendorSuccess(response.data));
        } else {
            yield put(actions.getVendorError(response.message));
        }
    } catch (error) {
        yield put(actions.getVendorError(error));
    }
}

function* getACodeResponse() {
    try {
        const response = yield call(getList, "/API/V1/Generic/GetACode");
        if (response?.statusCode === 1200) {
            yield put(actions.getACodeSuccess(response.data));
        } else {
            yield put(actions.getACodeError(response.message))
        }
    } catch (error) {
        yield put(actions.getACodeError(error))
    }
}


function* getPlanResponse({ payload: { data } }) {
    try {
        const response = yield call(getList, `/API/V1/Generic/GetPlan?ActionType=${data.ActionType}&Month=${data.Month}` );
        if (response?.statusCode == 1200) {
            yield put(actions.getPlanSuccess(response?.data));
        } else {
            yield put(actions.getPlanError(response?.message));
        }
    } catch (error) {
        yield put(actions.getPlanError(error));
    }
}

function* getBillingCodeListResponse({ payload: { data } }) {
    try {
        const response = yield call(getList, `/API/V1/Generic/GetBillingCode?ActionType=${data.ActionType}` );
        if (response?.statusCode == 1200) {
            yield put(actions.getBillingCodeSuccess(response?.data));
        } else {
            yield put(actions.getBillingCodeError(response?.message));
        }
    } catch (error) {
        yield put(actions.getBillingCodeError(error));
    }
}


export default function* rootSaga() {
    yield all([takeEvery(actions.GET_VENDOR, getVendorResponse)]);
    yield all([takeEvery(actions.GET_ACODE, getACodeResponse)]);
    yield all([takeEvery(actions.GET_PLAN, getPlanResponse)]);
    yield all([takeEvery(actions.GET_BILLING_CODE, getBillingCodeListResponse)]);

}
